import { render } from "./BreedingListModal.vue?vue&type=template&id=07f01bf7&ts=true"
import script from "./BreedingListModal.vue?vue&type=script&lang=ts"
export * from "./BreedingListModal.vue?vue&type=script&lang=ts"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__